export const LinkTheme = {
    Link: {
        baseStyle: ({ isUnderlined }) => {
            return {
                maxWidth: "100%",
                color: "primary.500",
                display: "inline",
                textDecorationLine: (isUnderlined ?? true) ? 'underline' : 'none',
            }
        },
    }
}